import TimesheetEntryList from "./pages/ListPage.vue";
import TimesheetEntryDetail from "./pages/FormPage.vue";
import TimesheetEntryIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/timesheet_entry",
    component: TimesheetEntryIndex,
    redirect: "/timesheet_entry/list",
    name: "timesheet_entry",
    children: [
      {
        path: "list",
        component: TimesheetEntryList,
        name: "timesheet_entry.list",
      },
      {
        path: "create",
        component: TimesheetEntryDetail,
        name: "timesheet_entry.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: TimesheetEntryDetail,
        name: "timesheet_entry.edit",
        props: { create: false },
      },
    ],
  },
];
